import { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context/User/UserContext';
import { getUserAzureGroup } from './_api';

/**
 * Custom hook used to determine whether logged-in user is a member of an Azure group.
 * @param {string} group Azure group unique identifier.
 * @returns {?boolean} nullable indication of Azure group membership where null indicates work-in-progress.
 */
export function useAzureAuthorized(group) {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;
	const [sIsAzureAuthorized, setIsAzureAuthorized] = useState(null);

	useEffect(() => {
		const render = async upn => {
			let isGroupMember = false;
			try {
				isGroupMember = await getUserAzureGroup(upn, group);
				setIsAzureAuthorized(isGroupMember);
			} catch {
			} finally {
				setIsAzureAuthorized(isGroupMember);
			}
		};

		if (user?.UPN) {
			render(user.UPN);
		}
	}, [user, group]);

	return sIsAzureAuthorized;
}
